import React, { createContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import RouteConstants from "../../../constants/routeConstants.json";
import { editPlanApi, getPlanFeatures, planViewApi } from "../../../api/Api";
import ContentData from "../../../constants/contentFile.json";
import {
  validateName,
  validateAmount,
  spaceCheck,
  validateNameWithNum
} from "../../../utils/service";
import { useCookies } from "react-cookie";

export const EditPlanContext = createContext({});
export const EditPlanContextProvider = ({ children }) => {
  const location = useLocation();
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [planName, setPlanName] = useState("");
  const [validatedName, setValidatedName] = useState("");
  const [price, setPrice] = useState("");
  const [maximumUsers, setMaximumUsers] = useState("");
  const [billing, setBilling] = useState("");
  const [description, setDescription] = useState("");
  const [features, setFeatures] = useState([]);
  const [newFeature, setNewFeature] = useState([]);
  const [validationPricing, setValidationPricing] = useState("");
    const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [validationMaximumUser, setValidationMaximumUser] = useState("");
  const [validationDescription, setValidationDescription] = useState("");
  const [validationBilling, setValidationBilling] = useState("");
  const [bill, setBill] = useState("");
  const [successAlertShow, setSuccessAlertShow] = useState(false);
  const [successAlertMessage, setSuccessAlertMessage] = useState("");
  const [trialDuration, setTrialDuration] = useState("");
  const [errorAlertShow, setErrorAlertShow] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [statusValue, setStatusValue] = useState(0);
  const [checkedFeatures, setCheckedFeatures] = useState([]);
  const [trialShow, setTrialShow] = useState(false);

  const [impactData, setImpactData] = useState("");

  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState(false);

  const planId = location?.state?.id;

  const descriptionValidation = (value) => {
    if (value === "") {
      setValidationDescription(ContentData.planManagement.enterDescriptionData);
      return false;
    } else {
      setValidationDescription("");
      return true;
    }
  };
  const navigate = useNavigate();

  const planListView = () => {
    navigate(RouteConstants.LIST_PLAN);
  };

  const handledescription = (e) => {
    const value = e.target.value;
    setDescription(value);

    // Clear error dynamically if the name is valid
    if (validationDescription && descriptionValidation(value)) {
      setValidationDescription("");
    }
  };

  const getPlanDetailApi = async (id) => {
    try {
      setSpinnerStatus(true);
      const getDetailData = await planViewApi(id);
      if (getDetailData.status === 200) {
        setSpinnerStatus(false);
        setSuccessAlertShow(false);
        setErrorAlertShow(false);
        setPlanName(getDetailData.data.data.plan?.name);
        setPrice(getDetailData.data.data.plan?.price);
        setMaximumUsers(getDetailData?.data?.data?.plan?.userCount);
        setDescription(getDetailData?.data?.data?.plan?.description);
        setBill(getDetailData?.data?.data?.plan?.billingCycle);
        setTrialDuration(getDetailData?.data?.data?.plan?.trialPeriod);
        // setFeatures(getDetailData?.data?.data?.plan?.features)
        setImpactData(getDetailData?.data?.data?.plan?.impact);
        setNewFeature(getDetailData?.data?.data?.plan?.features);
      }
    } catch (error) {
      setSuccessAlertShow(false);
      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || "Something went wrong...";

      setStatusValue(responseStatus);
      setErrorPopupMessage(errorMessage);
      setErrorPopup(true);

      if (responseStatus === 400) {
        setButtonText("Try Again");
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText("Login");
      } else {
        setButtonText("Try Again");
      }
    }
  };
  
  const planDetailData = (id) => {
    navigate(RouteConstants.PLAN_DETAILS, {state: {id}});
  };

  // Extract selected feature IDs from the response
  const selectedFeatureIds = newFeature.map((item) => item.planFeature._id);

  // Initialize checkedFeatures state
  useEffect(() => {
    if (newFeature && newFeature.length > 0) {
      const selectedFeatureIds = newFeature.map(
        (item) => item.planFeature._id
      );
      setCheckedFeatures(selectedFeatureIds);
    }
  }, [newFeature]); // Depend on newFeature


  const handleCheckboxChange = (id) => {
    setCheckedFeatures((prevChecked) =>
      prevChecked.includes(id)
        ? prevChecked.filter((featureId) => featureId !== id)
        : [...prevChecked, id]
    );
  };
  useEffect(() => {
    getPlanDetailApi(planId);
  }, []);

  const nameValidation = (value) => {
    if (value === "") {
      setValidatedName(ContentData.planManagement.planenterName);
      return false;
    } else if (!validateNameWithNum(value)) {
      setValidatedName(ContentData.planManagement.planvalidName);
      return false;
    } else {
      setValidatedName("");
      return true;
    }
  };

  const handleName = (e) => {
    const value = e.target.value;
    setPlanName(value);

    // Clear error dynamically if the name is valid
    if (validateName && nameValidation(value)) {
      setValidatedName("");
    }
  };

  const userValidation = (value) => {
    if (value === "") {
      setValidationMaximumUser(ContentData.planManagement.userCount);
      return false;
    } else if (validateName(value)) {
      setValidationMaximumUser(ContentData.planManagement.uservalidData);
      return false;
    } else {
      setValidationMaximumUser("");
      return true;
    }
  };

  const handleMaximumUser = (e) => {
    const value = e.target.value;
    setMaximumUsers(value);

    if (validationMaximumUser && userValidation(value)) {
      setValidationMaximumUser("");
    }
  };

  const priceValidation = (value) => {
    if (value === "") {
      setValidationPricing(ContentData.planManagement.enterPrice);
      return false;
    } else if (validateName(value)) {
      setValidationPricing(ContentData.planManagement.pricevalidData);
      return false;
    } else {
      setValidationPricing("");
      return true;
    }
  };

  const handlePrice = (e) => {
    const value = e.target.value;
    setPrice(value);

    if (validationPricing && priceValidation(value)) {
      setValidationPricing("");
    }
  };

  const billValidation = (value) => {
    if (value === "") {
      setValidationBilling("Select");
      return false;
    } else {
      setValidationBilling("");
      return true;
    }
  };

  const handleBillChange = (e) => {
    setBill(e.target.value);
    billValidation(e.target.value);
  };

  const handleTrial = (e) => {
    setTrialDuration(e.target.value);
  };

  const billingData = [
    {
      id: "monthly",
      duration: "Monthly",
    },
    {
      id: "yearly",
      duration: "Yearly",
    },
  ];

  const trialPeriods = [
    {
      id: "7",
      duration: "7 days trial period",
    },
    {
      id: "15",
      duration: "15 days trial period",
    },
    {
      id: "30",
      duration: "30 days trial period",
    },
  ];

  const getFeatureData = async () => {
    try {
      const data = await getPlanFeatures();
      if (data?.data?.statusCode === 200) {
        setFeatures(data?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getFeatureData();
  }, []);

  useEffect(() => {
    if (trialDuration > 0) {
      setTrialShow(true);
    } else {
      setTrialShow(false); 
    }
  }, [trialDuration]);

  // Convert checked features to the desired format
  const getFormattedFeatures = () => {
    return checkedFeatures.map((id) => ({ planFeature: id }));
  };

  const editPlanSubmit = async (e) => {
    e.preventDefault();

    const formattedFeatures = checkedFeatures.map((featureId) => {
      const featureDetails = features.find(
        (item) => item._id === featureId
      );
      return { planFeature: featureDetails };
    });
    const planDetails = {
      name: planName,
      billingCycle: bill,
      userCount: maximumUsers,
      price: price,
      description: description,
      features: formattedFeatures,
      trialPeriod: trialDuration ? trialDuration : 0,
      impact: impactData,
    };
    const nameValidate = nameValidation(planName);
    const priceValidate = priceValidation(price);
    const userValidate = userValidation(maximumUsers);
    const billingValidate = billValidation(bill);
    const descriptionValidate = descriptionValidation(description);

    if (
      nameValidate &&
      priceValidate &&
      userValidate &&
      billingValidate &&
      descriptionValidate
    ) {
      try {
        setSpinnerStatus(true);
        const getData = await editPlanApi(planId, planDetails);
        if (getData?.data?.statusCode === 200) {
          setErrorAlertShow(false);
          setSuccessAlertShow(true);
          setSpinnerStatus(false);
          setSuccessAlertMessage(getData?.data?.message);
        }
      } catch (error) {
        setStatusValue(error?.response?.data?.statusCode);
        if (error?.response?.data?.statusCode === 400) {
          setSpinnerStatus(false);
          const errorMessage = error?.response?.data?.message;
          setErrorAlertMessage(errorMessage);
          setErrorAlertShow(true);
          setSuccessAlertShow(false);
          setButtonText("Try Again");
        } else if (error?.response?.data?.statusCode === 401 || error?.response?.data?.statusCode === 403) {
          setSpinnerStatus(false);
          const errorMessage = error?.response?.data?.message;
          setErrorAlertMessage(errorMessage);
          setErrorAlertShow(true);
          setSuccessAlertShow(false);
          setButtonText("Login");
        } else {
          setSpinnerStatus(false);
          setErrorAlertMessage("Something went wrong...");
          setErrorAlertShow(true);
          setSuccessAlertShow(false);
          setButtonText("Try Again");
        }
      }
    }
  };

  const selectedImpactValue = (e) => {
    setImpactData(e.target.value);
  };

  const goToLogin = () => {
    removeCookie("x-access-token");
    navigate(RouteConstants.LOGIN);
  };

  const providerValue = {
    ContentData,
    spinnerStatus,
    planName,
    price,
    maximumUsers,
    billing,
    description,
    features,
    handleName,
    nameValidation,
    validatedName,
    handlePrice,
    billingData,
    priceValidation,
    validationPricing,
    handleMaximumUser,
    validationMaximumUser,
    userValidation,
    handleBillChange,
    validationBilling,
    descriptionValidation,
    handledescription,
    validationDescription,
    editPlanSubmit,
    checkedFeatures,
    setCheckedFeatures,
    handleCheckboxChange,
    trialShow,
    setTrialShow,
    trialPeriods,
    handleTrial,
    successAlertShow,
    successAlertMessage,
    errorAlertShow,
    setErrorAlertShow,
    errorAlertMessage,
    buttonText,
    statusValue,
    bill,
    trialDuration,
    selectedImpactValue,
    impactData,
    planListView,

    errorPopup,
    errorPopupMessage,
    goToLogin,
    setErrorPopup,
    planId,
    getPlanDetailApi,
    planDetailData,
    planId
  };
  return (
    <EditPlanContext.Provider value={providerValue}>
      {children}
    </EditPlanContext.Provider>
  );
};
